<template>
    <div>
        <DCard
            padding
        >
            <ResellerForm
                :errors="errors"
                :reseller-product="resellerProduct"
                :available-product-plans="availableProductPlans"
                :customer="customer"
                @submit="updateReseller"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ResellerForm from '~@/Components/Customers/ResellerProducts/Form'

export default {
    name: 'CustomerResellerProductsEdit',
    components: {
        ResellerForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        resellerProduct: {
            type: Object,
            default: () => { return {} }
        },
        availableProductPlans: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            contract: { customer_id: this.customer.id }
        }
    },
    methods: {
        updateReseller (form) {
            form.put(this.$route('customers.customers.reseller-products.update', {
                customer: this.customer.id,
                reseller_product: this.resellerProduct.id
            }))
        }
    }
}
</script>
